import React from 'react';

import propTypes from 'propTypes';
import { TranslatedMessage } from 'common/components/Intl';

const transitionDuration = 300;

const transitionStyles = {
  entering: {
    opacity: 1.0,
    transform: 'scale(1.0)',
    transitionDelay: 200,
  },
  exiting: {
    opacity: 0.0,
    transform: 'scale(0.8)',
  },
  exited: {
    opacity: 0.0,
    transform: 'scale(0.8)',
  },
};

const defaultStyle = {
  transitionProperty: 'opacity, transform',
  transitionDuration: `${transitionDuration}ms`,
  transitionTimingFunction: 'cubic-bezier(0.68, -0.55, 0.265, 1.85)',
};

export default class SuccessBanner extends React.Component {
  static propTypes = {
    quantity: propTypes.number,
    status: propTypes.string.isRequired,
  };

  state = {
    quantityDisplay: 0,
  };

  componentWillReceiveProps(nextProps) {
    const { quantity } = nextProps;
    if (quantity > 0) {
      this.setState({ quantityDisplay: quantity });
    }
  }

  render() {
    const { quantityDisplay } = this.state;
    const { status } = this.props;

    return (
      <div
        className="AddToCartSuccessModal__banner"
        style={{
          ...defaultStyle,
          ...transitionStyles[status],
        }}
      >
        <TranslatedMessage
          id={'cart.success_banner'}
          values={{ count: quantityDisplay }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/components/SuccessBanner.js